function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _wrapNativeSuper(t) { var r = "function" == typeof Map ? new Map() : void 0; return _wrapNativeSuper = function _wrapNativeSuper(t) { if (null === t || !_isNativeFunction(t)) return t; if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function"); if (void 0 !== r) { if (r.has(t)) return r.get(t); r.set(t, Wrapper); } function Wrapper() { return _construct(t, arguments, _getPrototypeOf(this).constructor); } return Wrapper.prototype = Object.create(t.prototype, { constructor: { value: Wrapper, enumerable: !1, writable: !0, configurable: !0 } }), _setPrototypeOf(Wrapper, t); }, _wrapNativeSuper(t); }
function _construct(t, e, r) { if (_isNativeReflectConstruct()) return Reflect.construct.apply(null, arguments); var o = [null]; o.push.apply(o, e); var p = new (t.bind.apply(t, o))(); return r && _setPrototypeOf(p, r.prototype), p; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _isNativeFunction(t) { try { return -1 !== Function.toString.call(t).indexOf("[native code]"); } catch (n) { return "function" == typeof t; } }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
import Swiper from 'swiper';
import { Navigation, Pagination, Thumbs } from 'swiper/modules';
var ProductInfo = /*#__PURE__*/function (_HTMLElement) {
  function ProductInfo() {
    var _this;
    _classCallCheck(this, ProductInfo);
    _this = _callSuper(this, ProductInfo);
    _this.sidecart = document.querySelector('side-cart');
    _this.initialized = false;
    _this.handleStickyWhenScrolling = function () {
      var stickyATC = _this.querySelector('.product-sticky-bar');
      var mainProductButtons = _this.querySelector('.product__buy-buttons') || document.createElement('div');
      if (!stickyATC) {
        return;
      }
      window.addEventListener('scroll', function () {
        _this.toggleStickyATC(mainProductButtons, stickyATC);
      });
    };
    return _this;
  }
  _inherits(ProductInfo, _HTMLElement);
  return _createClass(ProductInfo, [{
    key: "connectedCallback",
    value: function connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.init();
    }
  }, {
    key: "init",
    value: function init() {
      var _this2 = this;
      this.handleChangeVariant();
      this.handleStickyWhenScrolling();
      document.addEventListener('section:reload', function () {
        _this2.initSliders();
        _this2.initAccordions();
      });
    }
  }, {
    key: "updateURL",
    value: function updateURL(productInfo) {
      var productUrl = this.dataset.url;
      var variantId = productInfo === null || productInfo === void 0 ? void 0 : productInfo.dataset.selectedVariant;
      window.history.replaceState({}, '', "".concat(productUrl).concat(variantId ? "?variant=".concat(variantId) : ''));
    }
  }, {
    key: "getUpdatedSection",
    value: function () {
      var _getUpdatedSection = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var sectionId, productUrl, values, destination, response, responseText, html, _t;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.p = _context.n) {
            case 0:
              sectionId = this.dataset.section;
              productUrl = this.dataset.url;
              values = this.getSelectedValues();
              destination = document.getElementById("shopify-section-".concat(sectionId));
              _context.p = 1;
              _context.n = 2;
              return fetch("".concat(productUrl, "?section_id=").concat(sectionId, "&option_values=").concat(values.toString()), {
                method: 'GET'
              });
            case 2:
              response = _context.v;
              _context.n = 3;
              return response.text();
            case 3:
              responseText = _context.v;
              if (destination) {
                destination.outerHTML = responseText;
                if (typeof window.handleSectionRender === 'function') {
                  window.handleSectionRender();
                }
                html = new DOMParser().parseFromString(responseText, 'text/html');
                this.updateURL(html.querySelector('product-info'));
                this.updateBackInStockForm(html);
              }
              _context.n = 5;
              break;
            case 4:
              _context.p = 4;
              _t = _context.v;
            case 5:
              return _context.a(2);
          }
        }, _callee, this, [[1, 4]]);
      }));
      function getUpdatedSection() {
        return _getUpdatedSection.apply(this, arguments);
      }
      return getUpdatedSection;
    }()
  }, {
    key: "handleChangeVariant",
    value: function handleChangeVariant() {
      var _this3 = this;
      var inputs = this.querySelectorAll('input.product__variant-input');
      inputs.forEach(function (input) {
        input.addEventListener('change', /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
          var _this3$sidecart;
          return _regenerator().w(function (_context2) {
            while (1) switch (_context2.n) {
              case 0:
                _context2.n = 1;
                return _this3.getUpdatedSection();
              case 1:
                _this3.initAccordions();
                _this3.initSliders();
                (_this3$sidecart = _this3.sidecart) === null || _this3$sidecart === void 0 || _this3$sidecart.initializeAddEvent();
              case 2:
                return _context2.a(2);
            }
          }, _callee2);
        })));
      });
    }
  }, {
    key: "verifyIsVisible",
    value: function verifyIsVisible(element) {
      var item = element.getBoundingClientRect();
      return item.top >= 0 && item.left >= 0 && item.bottom <= (window.innerHeight || document.documentElement.clientHeight) && item.right <= (window.innerWidth || document.documentElement.clientWidth);
    }
  }, {
    key: "toggleStickyATC",
    value: function toggleStickyATC(reference, sticky) {
      if (this.verifyIsVisible(reference)) {
        sticky.classList.remove('visible');
      } else {
        sticky.classList.add('visible');
      }
    }
  }, {
    key: "getSelectedValues",
    value: function getSelectedValues() {
      var inputsSelected = this.querySelectorAll('input.product__variant-input:checked');
      var values = [];
      inputsSelected.forEach(function (input) {
        values.push(input.getAttribute('data-option-value-id'));
      });
      return values;
    }
  }, {
    key: "closingAccordions",
    value: function () {
      var _closingAccordions = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3(parent) {
        var accordionsToClose;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              accordionsToClose = parent.querySelectorAll(".accordion-js-item.is-open");
              accordionsToClose.forEach(function (item) {
                item.classList.remove("is-open");
                item.querySelector(".accordion-js-toggle").classList.remove("is-open");
                item.querySelector(".accordion-js-content").classList.remove("is-open");
              });
            case 1:
              return _context3.a(2);
          }
        }, _callee3);
      }));
      function closingAccordions(_x) {
        return _closingAccordions.apply(this, arguments);
      }
      return closingAccordions;
    }()
  }, {
    key: "initAccordions",
    value: function initAccordions() {
      var _this4 = this;
      var accordionToggles = document.querySelectorAll(".accordion-js-toggle");
      if (!accordionToggles) {
        return;
      }
      accordionToggles.forEach(function (accordionToggle) {
        accordionToggle.addEventListener("click", /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4() {
          var _accordionToggle$pare;
          var accordionContent, accordionItem;
          return _regenerator().w(function (_context4) {
            while (1) switch (_context4.n) {
              case 0:
                accordionContent = (_accordionToggle$pare = accordionToggle.parentElement) === null || _accordionToggle$pare === void 0 ? void 0 : _accordionToggle$pare.querySelector('.accordion-js-content');
                accordionItem = accordionToggle.parentElement;
                _context4.n = 1;
                return _this4.closingAccordions(accordionToggle.closest(".accordion-js"));
              case 1:
                if (accordionToggle.classList.contains("is-open")) {
                  accordionToggle.classList.remove("is-open");
                  accordionContent === null || accordionContent === void 0 || accordionContent.classList.remove("is-open");
                  accordionItem === null || accordionItem === void 0 || accordionItem.classList.remove("is-open");
                } else {
                  accordionToggle.classList.add("is-open");
                  accordionContent === null || accordionContent === void 0 || accordionContent.classList.add("is-open");
                  accordionItem === null || accordionItem === void 0 || accordionItem.classList.add("is-open");
                }
              case 2:
                return _context4.a(2);
            }
          }, _callee4);
        })));
      });
    }
  }, {
    key: "initSliders",
    value: function initSliders() {
      var productGalleryThumbs = new Swiper(".product-gallery-thumbs", {
        slidesPerView: 5,
        direction: 'vertical',
        watchOverflow: true,
        watchSlidesProgress: true,
        spaceBetween: 8
      });
      new Swiper(".product-gallery-main", {
        modules: [Navigation, Pagination, Thumbs],
        watchOverflow: true,
        watchSlidesProgress: true,
        preventInteractionOnTransition: true,
        pagination: {
          el: '.product-gallery-main-pagination',
          clickable: true
        },
        effect: 'fade',
        fadeEffect: {
          crossFade: true
        },
        thumbs: {
          swiper: productGalleryThumbs
        }
      });
    }
  }, {
    key: "updateBackInStockForm",
    value: function updateBackInStockForm(html) {
      var newBISForm = html.querySelector('.product__back-in-stock-form');
      var currentBISForm = this.querySelector('.product__back-in-stock-form');
      if (newBISForm && currentBISForm) {
        var variantId = newBISForm.dataset.variantId;
        var productId = newBISForm.dataset.productId;
        var productTitle = newBISForm.dataset.productTitle;
        var variantTitle = newBISForm.dataset.variantTitle;
        if (variantId && productId && productTitle && variantTitle) {
          var bisComponent = currentBISForm.querySelector('back-in-stock-form');
          if (bisComponent && typeof bisComponent.updateVariant === 'function') {
            bisComponent.updateVariant(variantId, productId, productTitle, variantTitle);
          }
        }
      }
    }
  }]);
}(/*#__PURE__*/_wrapNativeSuper(HTMLElement));
export default ProductInfo;